export interface GlobalClickObserver {
  onClick(target: EventTarget | null): void;
}

export const GlobalClickTracker = Symbol('GlobalClickTracker');
export interface GlobalClickTracker {
  addObserver(obs: GlobalClickObserver): void;
  removeObserver(obs: GlobalClickObserver): void;
}
